module.exports = __webpack_public_path__ + "a9c4bb7348f42626454c988dbde1d0a0.svg";